import React, {Fragment} from 'react';
import Stepper, { Step, StepButton } from 'material-ui/Stepper';
import {Props} from '../Builder/ElementProperties';

const ScaleElement = (props) => {

	let activeStep = props.element.value;

	return (
		<Fragment>
			<div style={{color:'black'}}>{props.element.label}</div>
			<Stepper activeStep={activeStep} alternativeLabel nonLinear>
				{props.element.options.map((label, index) => 
					<Step key={label + '_' + index}>
						<StepButton  onClick={e => { 
								props.element.value = index; 
								props.experiment.recordEvent({eventType:'User Action', actionType:'click', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'scale', value: index+1, expectedValue: props.element.expected });
								Props.onClickHandler({props});
							}}>
							{label}
						</StepButton>
					</Step>
				)}
			</Stepper>
		</Fragment>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.Label {...props} />
		<Props.Options {...props} />
		<Props.Expected {...props} />
		<Props.OnClick {...props} />
	</Fragment>
);



ScaleElement.type = 'scale';
ScaleElement.Properties = Properties;
ScaleElement.defaultJSON = {type: 'scale', id:'New Scale', x: 250, y:250, width:480, height:160, label:'This experiment was easy to use.', value:-1, 
	options:['Strongly disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly agree'], expected: '', onClick:''
};
export default ScaleElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/ScaleElement.js